export default __webpack_public_path__ + "static/meta_share_index-8ad64a77c3cdf992d4dc5d87be04f6b7.jpg";